import Vue from 'vue'
import VueRouter from 'vue-router'
import Vueaxios from "axios"
Vue.use(VueRouter)

import { baseURL } from '@/utils/baseURL.js'
Vueaxios.defaults.baseURL = baseURL // 'https://dpinterface.djplus.cn';//正式服地址
// Vueaxios.defaults.baseURL = 'http://192.168.2.212:16928'; //迭代测试服地址
// Vueaxios.defaults.baseURL = 'http://demo1.djplus.com.cn';//迭代测试服地址
Vue.prototype.axios = Vueaxios;

const routes = [
  {
    //带有底部
    path: '/',
    component: () => import('../views/footer.vue'),
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import('../views/index/index.vue')
      },
      {
        path: '/person',
        name: 'person',
        component: () => import("../views/person/person.vue")
      },
      {
        path: '/boutique',
        name: 'boutique',
        component: () => import("../views/boutiqueClass/boutique.vue")
      },
      {
        path: '/partyhome',
        name: 'partyhome',
        component: () => import('../views/partyhome/partyhome.vue')
      },
      {
        path: '/dataquery',
        name: 'dataquery',
        component: () => import('../views/dataQuery/dataQuery')
      },
      {
        path: '/leadaround',
        name: 'leadaround',
        component: () => import('../views/leadAround/leadAround')
      }
    ]
  },
  {
    path: '/header',
    //带有标头
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/header.vue'),
    children: [
      {
        path: '/objects',
        component: () => import('../views/index/objects')
      },
      {
        path: '/meeting',
        component: () => import('../views/index/meeting')
      },
      {
        path: '/introduction/introduction',
        component: () => import('../views/index/partyAllience/introduction/introduction')
      },
      // outside pages
      {
        path: '/outSide/qrcodeScan',
        component: () => import('../views/outSide/qrcodeScan')
      },
      {
        path: '/study/haveClass',
        component: () => import('../views/studyClass/haveClass')
      },
      {
        path: '/study/lookError',
        component: () => import('../views/studyClass/lookError')
      },
      {
        path: '/study/examDetail',
        component: () => import('../views/studyClass/examDetail')
      },
      {
        path: '/study/assessment',
        component: () => import('../views/studyClass/assessment')
      },
      {
        path: '/study/exam',
        component: () => import('../views/studyClass/exam')
      },
      {
        path: '/study/myClass',
        component: () => import('../views/studyClass/myClass')
      },
      {
        path: '/study/writeReport',
        name: '/study/writeReport',
        component: () => import('../views/studyClass/writeReport')
      },
      {
        path: '/study/detail',
        name: '/study/detail',
        component: () => import('../views/studyClass/studyDetail')
      },
      {
        path: '/study/index',
        name: '/study/index',
        component: () => import('../views/studyClass/studyClass')
      },
      // epidemic - letter
      {
        path: '/index/epidmic/letter',
        name: '/index/epidmic/letter',
        component: () => import('../views/index/epidemic/letter')
      },
      // epidemic
      {
        path: '/index/epidmic/epidmic',
        name: '/index/epidmic/epidmic',
        component: () => import('../views/index/epidemic/epidemic')
      },
      {
        //create Room Number
        path: "/person/createroom",
        name: "/person/createroom",
        component: () => import('../views/person/_createRoom')
      },
      {
        //chatRoom
        path: "/person/linechat",
        name: "/person/linechat",
        component: () => import('../views/person/_lineChat')
      },
      {
        path: '/partyhome/threemeeting/activeconsult',
        name: '/partyhome/threemeeting/activeconsult',
        component: () => import('../views/partyhome/threeMeeting/_activeConsult')
      },
      {
        path: '/partyhome/threemeeting/activerecord',
        name: '/partyhome/threemeeting/activerecord',
        component: () => import('../views/partyhome/threeMeeting/_activeRecord')
      },
      {
        path: '/themeedu/viedeoPlay',
        name: '/themeedu/viedeoPlay',
        component: () => import('../views/index/theme/_videoPlay')
      },
      {
        path: '/themeedu/viedeolist',
        name: '/themeedu/viedeolist',
        component: () => import('../views/index/theme/_videoList')
      }
      ,
      {
        path: '/person/netbody',
        name: '/person/netbody',
        component: () => import('../views/person/_netBody')
      },
      {
        path: "/gridservice",
        name: "/gridservice",
        component: () => import('../views/index/iconIndex/convenience/gridService')
      },
      {
        path: '/partyhome/internetclass',
        name: "/partyhome/internetclass",
        component: () => import('../views/partyhome/threeMeeting/_internetClass')
      },
      {
        //首页-数据查询-资料上传统计
        path: "/dataQuery/dataupload",
        name: "/dataQuery/dataupload",
        component: () => import("../views/dataQuery/_dataUpload")
      },
      {
        //首页-数据查询-三会一课统计
        path: "/dataQuery/threeclass",
        name: "/dataQuery/threeclass",

        component: () => import("../views/dataQuery/_threeClass")
      },
      {
        //首页-数据查询-发送信息
        path: "/dataQuery/sendmsg",
        name: "/dataQuery/sendmsg",

        component: () => import("../views/dataQuery/_sendMsg")
      },
      {
        //首页-数据查询-党员信息统计
        path: "/dataQuery/partymsg",
        name: "/dataQuery/partymsg",

        component: () => import("../views/dataQuery/_partyMsg")
      },
      {
        //首页-数据查询-办事服务统计
        path: "/dataQuery/dothings",
        name: "/dataQuery/dothings",

        component: () => import("../views/dataQuery/_doThings")
      },
      {
        //首页-数据查询-查询学习统计
        path: "/dataQuery/querystudy",
        name: "/dataQuery/querystudy",

        component: () => import("../views/dataQuery/_queryStudy")
      },
      {
        //首页-数据查询-学习资源比例统计
        path: "/dataQuery/resourceratio",
        name: "/dataQuery/resourceratio",
        component: () => import("../views/dataQuery/_resourceRatio")
      },
      {
        //首页-数据查询-热门课件统计
        path: "/dataQuery/hotclass",
        name: "/dataQuery/hotclass",

        component: () => import("../views/dataQuery/_hotClass")
      },
      {
        //首页-数据查询-党员人数统计
        path: "/dataQuery/partyBody",
        name: "/dataQuery/partyBody",
        component: () => import("../views/dataQuery/_partyBody")
      },
      {
        //首页-数据查询-注册人数统计
        path: "/dataQuery/loginBody",
        name: "/dataQuery/loginBody",

        component: () => import("../views/dataQuery/_loginBody")
      },
      {
        //首页-数据查询-学习排名
        path: "/dataQuery/studyrank",
        name: "/dataQuery/studyrank",
        component: () => import('../views/dataQuery/_studyRank')
      },
      {
        path: '/dutyWork',
        name: 'dutyWork',
        component: () => import('../views/index/iconIndex/dutyWork.vue')
      },
      {
        path: '/publicList',
        name: 'publicList',
        component: () => import('../views/publicList.vue')
      },
      {
        path: '/publicDetail',
        name: 'publicDetail',
        component: () => import('../views/publicDetail.vue')
      },
      {
        path: '/beautiful',
        name: 'beautiful',
        component: () => import('../views/index/iconIndex/beautifulHometown.vue')
      },
      {
        path: '/youthpartybrach',
        name: 'youthpartybrach',
        component: () => import('../views/index/iconIndex/youthPartyBrach.vue')
      },
      {
        path: '/convenienceserve',
        name: 'convenienceserve',
        component: () => import('../views/index/iconIndex/convenienceServe.vue')
      },
      {
        path: '/appointment',
        name: 'appointment',
        component: () => import('../views/index/iconIndex/convenience/appointment.vue')
      },
      {
        //主题教育
        path: '/themeedu',
        name: 'themeedu',
        component: () => import('../views/index/theme/themeEdu.vue')
      },
      {
        //嵌入视频
        path: '/iframevedio',
        name: 'iframevedio',
        component: () => import('../views/iframeVedio.vue')
      },
      {
        // 党建联盟
        path: '/partyAllience',
        name: 'partyAllience',
        component: () => import('../views/index/partyAllience/partyAllience.vue')
      },
      {
        //联盟成员
        path: '/partyCompany',
        name: 'partyCompany',
        component: () => import('../views/index/partyAllience/member/partyCompany.vue')
      },
      {
        // 联盟公司详情
        path: '/companyDetail',
        name: 'companyDetail',
        component: () => import('../views/index/partyAllience/member/companyDetail.vue')
      },
      {
        //联盟生活
        path: '/allienceLive',
        name: 'allienceLive',
        component: () => import('../views/index/partyAllience/live/allienceLive.vue')
      },
      {
        //联盟活动
        path: '/allienceActive',
        name: 'allienceActive',
        component: () => import('../views/index/partyAllience/active/allienceActive.vue')
      },
      {
        //联盟活动报名,
        path: '/allienceActive/allienceActiveReport',
        name: 'allienceActiveReport',
        component: () => import('../views/index/partyAllience/active/allienceActiveReport.vue')
      },
      {
        //党建联盟风采,
        path: '/allienceMienList',
        name: 'allienceMienList',
        component: () => import('../views/index/partyAllience/mien/allienceMienList.vue')
      },
      {
        //精品课件
        path: '/boutique/studyRecord',
        name: 'studyRecord',
        component: () => import('../views/boutiqueClass/studyRecord/studyRecord.vue')
      },
      {
        // 视频播放
        path: '/boutique/videoPlayer',
        name: 'videoPlayer',
        component: () => import('../views/boutiqueClass/videoPlayer.vue')
      },
      {
        // 视频详情
        path: '/videoDetail',
        name: 'videoDetail',
        component: () => import('../views/videoDetail.vue')
      },
      {
        // 精品课件-icon列表
        path: '/boutique/list',
        name: 'list',
        component: () => import('../views/boutiqueClass/list.vue')
      },
      {
        //党员之家 - 党务公开
        path: '/partyhome/partyaffairs',
        name: 'partyaffairs',
        component: () => import('../views/partyhome/_partyAffairs')
      },
      {
        //党员之家 - 职责分工
        path: '/partyhome/workduty',
        nmae: 'workduty',
        component: () => import('../views/partyhome/_workDuty')
      },
      {
        //党员之家 - 远程教育
        path: '/partyhome/remoteedu',
        name: 'remoteedu',
        component: () => import('../views/partyhome/_remoteEdu')
      },
      {
        //党员之家 - 三会一课 - 创建活动
        path: '/partyhome/_createactive',
        name: '/partyhome/_createactive',
        component: () => import('../views/partyhome/threeMeeting/_createActive')
      },
      {
        //党员之家 - 三会一课 - 编辑活动
        path: '/partyhome/_editactive',
        name: '/partyhome/_editactive',
        component: () => import('../views/partyhome/threeMeeting/_editActive')
      },
      {
        //党员之家 - 三会一课 - 活动签到
        path: '/partyhome/_signactive',
        name: '/partyhome/_signactive',
        component: () => import('../views/partyhome/threeMeeting/_signActive')
      },
      {
        //党员之家 - 党员管理
        path: '/partyhome/partymanage',
        name: '/partyhome/partymanage',
        component: () => import('../views/partyhome/partyManage/partyManage')
      },
      {
        //个人中心 - 我的收藏
        path: '/person/collect',
        name: '/person/collect',
        component: () => import('../views/person/_collect')
      },
      {
        //个人中心 - 我要学习
        path: '/person/study',
        name: '/person/study',
        component: () => import('../views/person/_study')
      },
      {
        //个人中心 - 积分说明
        path: '/person/integral/integralrecord',
        name: '/person/integral/integralrecord',
        component: () => import('../views/person/integral/_integralRecord')
      },
      {
        //个人中心 - 个人信息 - 编辑
        path: '/person/message/message',
        name: 'person/message/message',
        component: () => import('../views/person/message/message')
      },
      {
        //个人中心 - 我的足迹
        path: '/person/footprint',
        name: '/person/footprint',
        component: () => import('../views/person/_footprint')
      },
      {
        //个人中心 - 我的留言记录
        path: '/person/leaverecord',
        name: '/person/leaverecord',
        component: () => import('../views/person/_leaveRecord')
      },
      {
        //首页- 入党流程- 入党申请书
        path: '/index/joinparty/apply',
        name: '/index/joinparty/apply',
        component: () => import('../views/index/joinparty/_apply')
      },
      {
        //首页- 党员双报到
        path: '/partyReport',
        name: '/partyReport',
        component: () => import('../views/index/partyReport/partyReport')
      },
      /* 东坡志愿服务个人信息 */
      {
        path: '/profileMsg',
        name: '/profileMsg',
        component: () => import('../views/index/partyReport/profile/profileMsg')
      },
      /* 东坡志愿服务修改个人信息 */
      {
        path: '/changeProfile',
        name: '/changeProfile',
        component: () => import('../views/index/partyReport/profile/changeProfile')
      },
      {
        //首页- 党员双报到-志愿活动查看全部
        path: '/activityAll',
        name: '/activityAll',
        component: () => import('../views/index/partyReport/activityAll')
      },
      {
        //首页- 党员双报到-活动风采查看全部
        path: '/activityShow',
        name: '/activityShow',
        component: () => import('../views/index/partyReport/activityShow')
      },
      {
        //首页- 党员双报到-活动风采查看全部
        path: '/check',
        name: '/check',
        component: () => import('../views/index/partyReport/check')
      },
      {
        //首页- 党员双报到-志愿活动详情
        path: '/activityDetail',
        name: '/activityDetail',
        component: () => import('../views/index/partyReport/activityDetail')
      },
      {
        //首页- 党员双报到-上传活动凭证
        path: '/uploadVoucher',
        name: '/uploadVoucher',
        component: () => import('../views/index/partyReport/uploadVoucher')
      },
      {
        //首页- 党员双报到-活动风采详情
        path: '/activityShowDetail',
        name: '/activityShowDetail',
        component: () => import('../views/index/partyReport/activityShowDetail')
      },
      {
        //首页- 党员双报到-我的活动记录
        path: '/myActivity',
        name: '/myActivity',
        component: () => import('../views/index/partyReport/myActivity/myActivity')
      },
      {
        //首页- 党员双报到-我的活动记录
        path: '/createdActivity',
        name: '/createdActivity',
        component: () => import('../views/index/partyReport/myActivity/createdActivity')
      },
      {
        //首页- 党员双报到-个人活动详情
        path: '/myactiDetail',
        name: '/myactiDetail',
        component: () => import('../views/index/partyReport/myActivity/myactiDetail')
      },
      {
        //首页- 党员双报到-管理志愿服务活动
        path: '/management',
        name: '/management',
        component: () => import('../views/index/partyReport/management/management')
      },
      {
        //首页- 党员双报到-参与用户信息
        path: '/reportuser',
        name: '/reportuser',
        component: () => import('../views/index/partyReport/management/reportuser')
      },
      {
        //首页- 党员双报到-活动凭证审核
        path: '/reportDetail',
        name: '/reportDetail',
        component: () => import('../views/index/partyReport/management/reportDetail')
      },
      {
        //首页- 党员双报到-创建志愿活动风采
        path: '/createdActivityShow',
        name: '/createdActivityShow',
        component: () => import('../views/index/partyReport/management/createdActivityShow')
      },
      {
        //首页- 党员双报到-创建志愿活动
        path: '/manageCreatedActi',
        name: '/manageCreatedActi',
        component: () => import('../views/index/partyReport/management/manageCreatedActi')
      },
      {
        //首页- 党员双报到-个人活动审核
        path: '/personActivity',
        name: '/personActivity',
        component: () => import('../views/index/partyReport/management/personActivity')
      },
      {
        //首页- 党员双报到-个人活动审核详情
        path: '/personActivityDetail',
        name: '/personActivityDetail',
        component: () => import('../views/index/partyReport/management/personActivityDetail')
      },
      {
        //首页- 党员双报到-党员报道审核
        path: '/partyAudit',
        name: '/partyAudit',
        component: () => import('../views/index/partyReport/management/partyAudit')
      },
      {
        //首页- 党员双报到-党员报道审核详情
        path: '/partyAuditDetail',
        name: '/partyAuditDetail',
        component: () => import('../views/index/partyReport/management/partyAuditDetail')
      },
      {
        //扫描二维码进入
        path: '/hualu',
        name: '/hualu',
        component: () => import('../views/index/partyReport/hualu/hualu.vue')
      },
      {
        //首页 两星党建
        path: '/twoStar',
        name: '/twoStar',
        component: () => import('../views/index/twoStar/twoStar.vue')
      },
      {
        //首页 华陆大厦党委
        path: '/hualuParty',
        name: '/hualuParty',
        component: () => import('../views/index/hualuParty/hualuParty.vue')
      },
      {
        //首页 华陆大厦党委 
        path: '/hualuParty/partyCompany',
        name: '/hualuParty/partyCompany',
        component: () => import('@/views/index/twoStar/member/partyCompany.vue')
      },
      {
        //首页 华陆大厦党委 联盟生活
        path: '/hualuParty/allienceLive',
        name: '/hualuParty/allienceLive',
        component: () => import('@/views/index/twoStar/live/allienceLive.vue')
      },
      {
        //首页 华陆大厦党委 联盟活动
        path: '/hualuParty/allienceActive',
        name: '/hualuParty/allienceActive',
        component: () => import('@/views/index/twoStar/active/allienceActive.vue')
      },
      {
        //首页 华陆大厦党委 联盟风采
        path: '/hualuParty/allienceMienList',
        name: '/hualuParty/allienceMienList',
        component: () => import('@/views/index/twoStar/mien/allienceMienList.vue')
      },
      {
        //首页 华陆大厦党委 简介
        path: '/hualuParty/introduction',
        name: '/hualuParty/introduction',
        component: () => import('@/views/index/twoStar/introduction/introduction.vue')
      },
      {
        //首页 东坡水街商圈综合党委
        path: '/dpCommerce',
        name: '/dpCommerce',
        component: () => import('../views/index/dpCommerce/dpCommerce.vue')
      },
      {
        //首页 东坡水街商圈综合党委 党员报到
        path: '/dpCommerceReport',
        name: '/dpCommerceReport',
        component: () => import('../views/index/dpCommerce/dpCommerceReport.vue')
      },
      {
        //首页 东坡水街商圈综合党委 介绍
        path: '/dpCommeIntroduce',
        name: '/dpCommeIntroduce',
        component: () => import('../views/index/dpCommerce/dpCommeIntroduce.vue')
      },
      {
        //首页 东坡水街商圈综合党委 议事平台
        path: '/platform',
        name: '/platform',
        component: () => import('../views/index/dpCommerce/fourItem/platform')
      },
      {
        //首页 东坡水街商圈综合党委 水街联盟
        path: '/sjUnion',
        name: '/sjUnion',
        component: () => import('../views/index/dpCommerce/fourItem/sjUnion')
      },
      {
        //首页 东坡水街商圈综合党委 水街联盟 联盟简介
        path: '/unionIntroduce',
        name: '/unionIntroduce',
        component: () => import('../views/index/dpCommerce/fourItem/unionIntroduce')
      },
      {
        //首页 东坡水街商圈综合党委 网红水街映党红
        path: '/netCelebritySJ',
        name: '/netCelebritySJ',
        component: () => import('../views/index/dpCommerce/fourItem/netCelebritySJ')
      },
      {
        //首页 东坡水街商圈综合党委 服务资源
        path: '/serviceResource',
        name: '/serviceResource',
        component: () => import('../views/index/dpCommerce/fourItem/serviceResource')
      },
      {
        //首页 东坡人才 
        path: '/dpTalent',
        name: '/dpTalent',
        component: () => import('@/views/index/dpTalent/dpTalent.vue')
      },
      {
        //首页 东坡人才  视频播放
        path: '/dpTalent/videoPlay',
        name: '/dpTalent/videoPlay',
        component: () => import('@/views/index/dpTalent/videoPlay.vue')
      },
      {
        //首页 东坡人才  图文详情
        path: '/dpTalent/newsDetail',
        name: '/dpTalent/newsDetail',
        component: () => import('@/views/index/dpTalent/newsDetail.vue')
      },
      {
        //首页 东坡人才  视频列表
        path: '/dpTalent/yearTalent',
        name: '/dpTalent/yearTalent',
        component: () => import('@/views/index/dpTalent/yearTalent.vue')
      },
      {
        //首页 东坡人才  视频列表
        path: '/dpTalent/showMemo',
        name: '/dpTalent/showMemo',
        component: () => import('@/views/index/dpTalent/showMemo.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    // 直播页
    path: '/living',
    name: 'living',
    component: () => import('../views/living.vue')
  },
  {
    //党员之家 - 三会一课首页
    path: '/partyhome/threemeeting',
    name: 'threemeeting',
    component: () => import('../views/partyhome/threeMeeting/threeMeeting')
  },
  {
    //个人中心 - 积分
    path: '/person/integral',
    name: '/person/integral',
    component: () => import('../views/person/integral/integral')
  },
  {
    //个人中心 - 积分记录
    path: '/person/integral/integraldetail',
    name: '/person/integral/integraldetail',
    component: () => import('../views/person/integral/_integralDetail')
  },
  {
    //个人中心 - 我要留言
    path: '/person/leaveboard',
    name: '/person/leaveboard',
    component: () => import('../views/person/_leaveBoard')
  },
  {
    //入党流程-首页
    path: '/index/joinparty',
    name: '/index/joinparty',
    component: () => import('../views/index/_joinParty')
  },
  {
    //入党流程-点击查看
    path: '/index/joinparty/joinpartyflow',
    name: '/index/joinparty/joinpartyflow',
    component: () => import('../views/index/joinparty/joinPartyFlow')
  },
  {
    //入党流程 - 视频列表
    path: '/index/joinparty/videolist',
    name: '/index/joinparty/videolist',
    component: () => import('../views/index/joinparty/_videoList')
  },
  {
    //入党流程 - 视频列表
    path: '/test',
    name: 'test',
    component: () => import('../views/component/chooseParty')
  },
  {
    path: '/dppad',
    name: '/dppad',
    component: () => import('../views/dppad')
  },
  // qrcode scan Msg
  {
    path: '/outSide/qrMsg',
    component: () => import('@/views/outSide/msg.vue')
  },
  {
    // loginDp
    path: '/loginDp',
    name: '/loginDp',
    component: () => import('../views/index/partyReport/loginRegis/loginDp')
  },
  {
    path: '/perfectMsgLogin',
    name: '/perfectMsgLogin',
    component: () => import('../views/index/partyReport/loginRegis/perfectMsgLogin')
  },
  {
    path: '/updatePassword',
    name: '/updatePassword',
    component: () => import('../views/index/partyReport/loginRegis/updatePassword')
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router
